var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6606 12.3145C17.2073 12.3145 11.957 17.5642 11.957 24.0175C11.957 30.4713 17.2073 35.7216 23.6606 35.7216C30.1139 35.7216 35.3641 30.4713 35.3641 24.0175C35.3641 17.5647 30.1139 12.3145 23.6606 12.3145ZM17.1946 30.4827L20.5159 22.5845L25.0941 27.1614L17.1946 30.4827ZM26.8124 25.4321L22.2448 20.8657L30.1256 17.5525L26.8124 25.4321Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6595 0.570312C10.6813 0.570312 0.160156 11.0923 0.160156 24.07C0.160156 37.0477 10.6813 47.5706 23.6595 47.5706C36.6377 47.5706 47.1602 37.0484 47.1602 24.07C47.1602 11.0916 36.6377 0.570312 23.6595 0.570312ZM23.66 38.1609C15.8625 38.1609 9.51839 31.8168 9.51839 24.0189C9.51839 16.2214 15.862 9.87779 23.66 9.87779C31.458 9.87779 37.8016 16.2214 37.8016 24.0189C37.8016 31.8164 31.4575 38.1609 23.66 38.1609Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco06);
export default __webpack_public_path__ + "static/media/ico-06.da58aa774a66b15afd7d561ef1cae4d3.svg";
export { ForwardRef as ReactComponent };